import React from 'react';
import { Paper, Table, TableContainer, TableBody, TableRow, TableCell, Tooltip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

const useStyles = makeStyles((theme) => ({
    checkout: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: theme.spacing(3),
        width: '250px',
    },
    discount: {
        color: 'green',
    },
}));

//TODO: This should be same component on cart and checkout
const CheckoutTab = (props) => {

    const classes = useStyles();
    const subtotal = props.cartFees.subTotal
    const afterDiscount = subtotal - props.cartFees.coupons.toFixed(2);

    return (
        <Paper className={classes.checkout}>
            <Typography variant='h5'>Checkout</Typography>

            <TableContainer className={classes.table}>
                <Table size='small'>
                    <TableBody>
                        <TableRow >
                            <TableCell component="th" scope="row"><Typography>Material:</Typography></TableCell>
                            <TableCell align='right'><Typography>${props.cartFees.subTotal.toFixed(2)}</Typography></TableCell>
                        </TableRow>
                        {props.cartFees.coupons > 0 &&
                            <TableRow >
                                <TableCell component="th" scope="row" className={classes.discount}><Typography>Discount:</Typography></TableCell>
                                <TableCell align='right' className={classes.discount}><Typography>${props.cartFees.coupons.toFixed(2)}</Typography></TableCell>
                            </TableRow>
                        }
                        {props.cartFees.coupons > 0 &&
                            <TableRow >
                                <TableCell component="th" scope="row"><Typography><strong>After Discount:</strong></Typography></TableCell>
                                <TableCell align='right'><Typography><del style={{ color: 'green' }}>${subtotal.toFixed(2)}</del> <strong>${afterDiscount.toFixed(2)}</strong></Typography></TableCell>
                            </TableRow>
                        }
                        {props.cartFees.shipping > 0 &&
                            <TableRow >
                                <TableCell component="th" scope="row">Shipping:</TableCell>
                                <TableCell align='right'>${props.cartFees.shipping.toFixed(2)}</TableCell>
                            </TableRow>
                        }
                        <TableRow >
                            <TableCell component="th" scope="row">Carbon Fee:</TableCell>
                            <TableCell align='right'>${props.cartFees.cartTaxes['Carbon Fees'] && props.cartFees.cartTaxes['Carbon Fees'].toFixed(2)}</TableCell>
                        </TableRow>
                        {'palletFee' in props.cartFees &&
                            <TableRow >
                                <TableCell component="th" scope="row" style={{ display: 'flex', alignItems: 'center' }}>
                                    Refundable Pallet Deposit:
                                    <Tooltip title="Refundable on return of pallets">
                                        <HelpOutlineIcon />
                                    </Tooltip>
                                </TableCell>
                                <TableCell align='right'>${props.cartFees.palletFee.totalFee.toFixed(2)}</TableCell>
                            </TableRow>}
                        <TableRow >
                            <TableCell component="th" scope="row">GST:</TableCell>
                            <TableCell align='right'>${props.cartFees.cartTaxes['GST'] && props.cartFees.cartTaxes['GST'].toFixed(2)}</TableCell>
                        </TableRow>
                        {props.cartFees.cartTaxes['PST'] > 0 &&
                            <TableRow >
                                <TableCell component="th" scope="row">PST:</TableCell>
                                <TableCell align='right'>${props.cartFees.cartTaxes['PST'] && props.cartFees.cartTaxes['PST'].toFixed(2)}</TableCell>
                            </TableRow>
                        }

                        {props.cartFees.giftCardApplied > 0 &&
                            <TableRow >
                                <TableCell component="th" scope="row"><strong>Gift Cards:</strong></TableCell>
                                <TableCell align='right'><strong>${props.cartFees.giftCards && props.cartFees.giftCards.reduce((total, current) => total + current.currentValue, 0).toFixed(2)}</strong></TableCell>
                            </TableRow>
                        }

                        {props.cartFees.giftCardRemains > 0 &&
                            <TableRow >
                                <TableCell component="th" scope="row">Gift Card Remaining:</TableCell>
                                <TableCell align='right'>${props.cartFees.giftCardRemains && props.cartFees.giftCardRemains.toFixed(2)}</TableCell>
                            </TableRow>
                        }

                        {props.payingHalf ? 
                        <>
                        <TableRow >
                            <TableCell component="th" scope="row"><Typography><strong>Due Now:</strong></Typography></TableCell>
                            {
                            props.cartFees.giftCardApplied > 0
                            ?
                                <TableCell align='right'><Typography><del style={{ color: 'green' }}>${(Number(props.cartFees.total - props.cartFees.halfCost)).toFixed(2)}</del> <strong>${((Number(props.cartFees.total - props.cartFees.halfCost).toFixed(2) - Number(props.cartFees.giftCardApplied).toFixed(2))).toFixed(2)}</strong></Typography></TableCell>
                            :
                                <TableCell align='right'><Typography><strong>${(props.cartFees.total - props.cartFees.halfCost).toFixed(2)}</strong></Typography></TableCell>
                            }
                        </TableRow>
                        <TableRow >
                        <TableCell component="th" scope="row"><Typography><strong>Due On Completion:</strong></Typography></TableCell>
                        <TableCell align='right'><Typography><strong>${(props.cartFees.halfCost).toFixed(2)}</strong></Typography></TableCell>
                        
                    </TableRow>
                    </>
                        :<TableRow >
                            <TableCell component="th" scope="row"><Typography><strong>Total:</strong></Typography></TableCell>
                            {
                            props.cartFees.giftCardApplied > 0
                            ?
                                <TableCell align='right'><Typography><del style={{ color: 'green' }}>${(Number(props.cartFees.total)).toFixed(2)}</del> <strong>${((Number(props.cartFees.total).toFixed(2) - Number(props.cartFees.giftCardApplied).toFixed(2))).toFixed(2)}</strong></Typography></TableCell>
                            :
                                <TableCell align='right'><Typography><strong>${props.cartFees.total.toFixed(2)}</strong></Typography></TableCell>
                            }
                        </TableRow>}
                        
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )
}

export default CheckoutTab;